export default __webpack_public_path__ + "static/media/810.0deec970.png";